export default __webpack_public_path__ + "static/media/hht2_ep17_speaking_01.20d52628.png";